export function validateFileSize (file, maxSize) {
    return file.size / 1024 / 1024 < maxSize
}
